import { MoneyConnectClientAPI } from './axios-service-creator';

export const ModelPortfolioAPI = {
  getUnitholders: () => MoneyConnectClientAPI.get('/consolidate/model-portfolio/unitholder-mutual-fund'),
  getAllocationMutualFund: (payload) => MoneyConnectClientAPI.post('/consolidate/model-portfolio/allocation-mutual-fund', payload),

}